export default __webpack_public_path__ + "static/media/castlecryptoLOGO.10448cdd.png";